import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home/Home";
import NotFound from "../pages/NotFound/NotFound";
import BPOPage from "../pages/BPO/BPOPage";
import WebDev from "../pages/WebDev/Page";
import EAFPage from "../pages/EAF/EAFPage";
import DefaultLayout from "../layouts/DefaultLayout";
import AboutUsPage from "../pages/AboutUs/AboutUsPage";
import BlogPage from "../pages/BlogPage/BlogPage";
import BlogDetailPage from "../pages/BlogPage/BlogDetailPage";
import SucessfulStoriesPage from "../pages/Stories/SucessfulStoriesPage";
import SuccessStoryDetailPage from "../pages/Stories/SuccessfulStoriesDetailPage";
import TermsAndConditionPage from "../pages/Terms&Condition/Page";
import PrivacyPolicyPage from "../pages/PrivacyPolicy/Page";

const AppRoutes = () => {
  return (
    <Routes>
            {/* Pages WITH MainLayout */}
      <Route element={<DefaultLayout />}>
       <Route path="/" element={<Home />} />
       <Route path="/about-us" element={<AboutUsPage/>}/>
        <Route path="/bpo" element={<BPOPage />} />
        <Route path="/web-development" element={<WebDev />} />
        <Route path="/address-finder" element={<EAFPage />} />
        <Route path="/blogs" element={<BlogPage/>}/>
        <Route path="/blogs/:slug" element={<BlogDetailPage />} />
        <Route path="/success-stories" element={<SucessfulStoriesPage/>}/>
        <Route path="/success-stories/:slug" element={<SuccessStoryDetailPage />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditionPage/>}/>
        <Route path="/privacy-policy" element={<PrivacyPolicyPage/>}/>
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
